<template>
    <tr>
        <td style="line-height: 1; vertical-align: center; border-top: 1px solid #ddd; padding: 4px 16px;">
            <span style="font-size: 12px; color: #000;">
                {{ title }} (+{{ amount }}%)
            </span>
            <br/>
            <span style="font-size: 11px; color: #464646;">
                1 &times; <pm-price :value="unitPrice" hide-currency />
            </span>
        </td>
        <td style="vertical-align: center; text-align: right; border-top: 1px solid #ddd; padding: 4px 16px;">
            <pm-price style="font-size: 12px; text-align: right; font-weight: normal!important;" :value="unitPrice" :currency="$store.state.currency" />
        </td>
    </tr>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        amount: {
            type: Number,
            default: 1,
        },
        unitPrice: {
            type: Number,
            default: 0,
        }
    }
}
</script>
